/* eslint-disable camelcase */
import { Field, Select } from '@hotjar/hotsauce';
import {
  incomingFeedbackLanguageChoices,
  languageChoices as surveyLanguageChoices,
} from '@hotjar/insights-common/constants/legacy';
import { useTranslation } from '@hotjar/translations';

interface LanguageOption {
  value: string;
  label: string;
  native_label: string;
}

export interface LanguageSelectorProps {
  type: 'feedback' | 'survey';
  language: string;
  onLanguageChanged: (newLanguage: LanguageOption['value']) => void;
}

export function LanguageSelector({
  type,
  language,
  onLanguageChanged,
}: LanguageSelectorProps): JSX.Element {
  const { t } = useTranslation('feedback', { keyPrefix: 'wizard.section.appearance.language' });
  const languageOptions: Record<LanguageSelectorProps['type'], LanguageOption[]> = {
    survey: surveyLanguageChoices,
    feedback: incomingFeedbackLanguageChoices,
  };

  return (
    <Field inputId="languageSelector" labelText={t('title')} helperText={t(`helper.${type}`)}>
      <Select
        id="languageSelector"
        value={language}
        onChange={({ target }) => onLanguageChanged(target.value)}
        name="language"
      >
        {languageOptions[type].map(({ value }) => (
          <option value={value} key={value}>
            {t(`options.${value}`)}
          </option>
        ))}
      </Select>
    </Field>
  );
}
